<template>
  <RevCard class="px-32 py-28">
    <RevContentBlock
      :image-props="{
        alt: '',
        height: 257,
        src: '/img/customer-care/trip-mountains.svg',
        width: 465,
      }"
      :surtitle="i18n(translations.surtitle)"
      :title="wordings.title"
    >
      <span class="body-1">
        {{ wordings.description }}
      </span>
    </RevContentBlock>
  </RevCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevContentBlock } from '@ds/components/ContentBlock'

import { PUBLICATION_STATE } from '../../../../Listings.constants'

import translations from './EmptyState.translations'

const i18n = useI18n()

const props = defineProps<{
  publicationState: string
}>()

const wordings = computed(() => {
  let description = ''
  let title = ''

  switch (props.publicationState) {
    case PUBLICATION_STATE.ONLINE:
      description = i18n(translations.descriptionActive)
      title = i18n(translations.titleActive)
      break

    case PUBLICATION_STATE.MISSING_PRICE_OR_COMMENT:
      description = i18n(translations.descriptionMissingInfos)
      title = i18n(translations.titleMissingInfos)
      break

    case PUBLICATION_STATE.IN_VALIDATION:
      description = i18n(translations.descriptionInValidation)
      title = i18n(translations.titleInValidation)
      break

    case PUBLICATION_STATE.DISABLED:
      description = i18n(translations.descriptionArchived)
      title = i18n(translations.titleArchived)
      break

    default:
      break
  }

  return { description, title }
})
</script>
